import React, { createContext, useContext, useState } from 'react';

const ProjectContext = createContext({});

export const ProjectContextProvider = ({ children, value }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [drawerMeta, setDrawerMeta] = useState({
    type: 'sample_type',
    testId: null,
    id: null,
    value: null,
    data: null,
  });

  const openEditModal = ({ type, id, testId, value, data }) => {
    setDrawerMeta({ type, id, testId, value, data });
    setIsDrawerOpen(true);
  };

  return (
    <ProjectContext.Provider
      value={{
        openEditModal,
        isDrawerOpen,
        setIsDrawerOpen,
        drawerMeta,
        reFetchProject: value.reFetchProject,
        refetchProjectTags: value.refetchProjectTags,
        projectId: value.projectId,
        projectStatus: value.projectStatus,
        testAmountChangeHandler:
          value.testAmountChangeHandler || value.reFetchProject,
      }}
    >
      {children}
    </ProjectContext.Provider>
  );
};

export const useProjectContext = () => {
  const {
    projectId,
    isDrawerOpen,
    setIsDrawerOpen,
    openEditModal,
    drawerMeta,
    reFetchProject,
    refetchProjectTags,
    testAmountChangeHandler,
    projectStatus,
  } = useContext(ProjectContext);
  return {
    projectId,
    isDrawerOpen,
    setIsDrawerOpen,
    openEditModal,
    drawerMeta,
    reFetchProject,
    refetchProjectTags,
    testAmountChangeHandler,
    projectStatus,
  };
};
